<template>
    <section class="my-3">
        <template>
            <div class="form-group row mb-1">
                <label for="coupon" class="col-sm-2 col-form-label font-weight-bold">Coupon</label>
                <div class="col-sm-5 py-2 py-sm-0">
                    <input
                        :disabled="validCoupon.valid"
                        type="text"
                        class="form-control form-control-sm"
                        id="coupon"
                        name="coupon"
                        placeholder="Insert your coupon code"
                        @keyup="couponAttempt.submitted = false"
                        v-model="couponAttemptId"
                    />
                </div>
                <div class="col-sm-5">
                    <button
                        v-if="couponAttempt.loading"
                        @click.prevent=""
                        class="btn btn-sm btn-dark text-white font-weight-bold text-uppercase"
                    >
                        <i class="fa fa-spin fa-circle-o-notch mr-2"></i>Processing...
                    </button>
                    <button
                        v-if="!couponAttempt.loading && !validCoupon.valid"
                        dusk="verify"
                        @click.prevent="verifyCoupon()"
                        class="btn btn-sm btn-dark text-white font-weight-bold text-uppercase"
                    >
                        Verify Code
                    </button>
                    <template v-if="helpers._get(subscription, 'is_subscribed', false)">
                        <button
                            v-if="!couponAttempt.loading && validCoupon.valid"
                            @click.prevent="applyCoupon()"
                            id="apply"
                            dusk="apply"
                            class="btn btn-sm btn-success text-white font-weight-bold text-uppercase"
                        >
                            Apply coupon
                        </button>
                    </template>
                    <template v-else="">
                        <button
                            v-if="!couponAttempt.loading && validCoupon.valid"
                            disabled="disabled"
                            id="ready"
                            class="btn btn-sm btn-success text-white font-weight-bold text-uppercase"
                        >
                            Ready
                        </button>
                    </template>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <span v-if="validCoupon.valid" class="font-italic small">
                        <i class="fa fa-check-circle text-success mr-2"></i>
                        The coupon <strong>{{ validCoupon.id }}</strong> is valid for
                        {{
                            validCoupon.percent_off
                                ? `${validCoupon.percent_off}%`
                                : `$${(validCoupon.amount_off / 100).toFixed(2)}`
                        }}
                        off
                        {{
                            validCoupon.duration_in_months
                                ? ` for ${validCoupon.duration_in_months} months `
                                : ``
                        }}
                        and can be redeemed.
                    </span>
                    <small v-if="couponAttempt.submitted && !validCoupon.valid" class="font-italic"
                        ><i class="fa fa-times-circle text-danger mr-2"></i>Your coupon code
                        <strong>{{ validCoupon.id || "" }}</strong> is not valid.</small
                    >
                </div>
            </div>
        </template>
        <template v-if="subscription && subscription.coupon">
            <div class="row">
                <div class="col">
                    <span class="small font-italic">
                        <i class="fa fa-check-circle text-success mr-2"></i>
                        You are currently using the coupon <strong>{{ subscription.coupon }}</strong
                        >.
                    </span>
                </div>
            </div>
        </template>
    </section>
</template>

<script>
import { helpers } from "../../plugins/helpers";

export default {
    name: "CouponWidget",
    props: ["user", "subscription"],
    data() {
        return {
            helpers,
            // these two variables are needed as a reactive variable instead of just being in the objects
            couponAttemptId: "",
            isCouponValid: false,
            couponAttempt: {
                id: "",
                submitted: false,
                loading: false,
                applied: false,
            },
            validCoupon: {
                id: null,
                valid: false,
                submitted: false,
                loading: false,
                percent_off: null,
                amount_off: null,
                name: null,
            },
        };
    },

    watch: {
        // had to make two watchers because computed wasn't working for me for some reason.
        couponAttemptId: function() {
            const isSafeToSubmit = this.couponAttemptId === "" || this.isCouponValid;
            this.$emit("safeToSubmitChange", isSafeToSubmit);
        },
        isCouponValid: function() {
            const isSafeToSubmit = this.couponAttemptId === "" || this.isCouponValid;
            this.$emit("safeToSubmitChange", isSafeToSubmit);
        },
    },

    methods: {
        verifyCoupon() {
            if (this.couponAttemptId) {
                this.couponAttempt.loading = true;
                axios
                    .get(
                        `/api/users/${this.user.id}/subscription/coupon/${
                            this.couponAttemptId
                        }/verify`
                    )
                    .then(r => {
                        this.validCoupon = r.data;
                        if (!this.validCoupon.valid) {
                            this.couponAttempt.submitted = true;
                            this.$emit("invalid-coupon");
                        } else {
                            this.$emit("valid-coupon", this.validCoupon.id);
                            this.isCouponValid = true;
                        }
                        this.couponAttempt.loading = false;
                    })
                    .catch(e => {
                        console.error(e);
                        this.couponAttempt.loading = false;
                    });
            } else {
                this.couponAttempt.submitted = true;
            }
        },

        applyCoupon() {
            if (!this.validCoupon || !this.validCoupon.valid) {
                return;
            }
            this.couponAttempt.loading = true;
            axios
                .get(`/api/users/${this.user.id}/subscription/coupon/${this.validCoupon.id}/apply`)
                .then(r => {
                    if (r.data.success) {
                        this.couponAttempt.applied = true;
                        this.$emit("coupon-applied", this.validCoupon.id);
                    }
                    this.couponAttempt.loading = false;
                })
                .catch(e => {
                    console.error(e);
                    this.couponAttempt.loading = false;
                });
        },
    },
};
</script>

<style scoped></style>
